import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DigitalCardView from "./CardView";
import NoResult from "../NoResult";
import CustomScroll from "react-custom-scroll";
import Preloader from "../../Preloader";
import AuthCentral from "../../../services/AuthCentral/AuthService";
import { getDocument } from "../../../services/DocumentStore/MetadataService";
import CoreConsts from "../../../constants/CoreConsts";
import ServiceUrls from "../../../constants/ServiceUrls";
import { SupportedDocumentTypeService } from "oasis-document-viewer";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import FileService from "../../../services/DocumentStore/FileService";
import AuditService from "../../../services/DocumentStore/AuditService";

const {
  downloadFileFromClientBucket,
  downloadDocuments,
  downloadFilePreviewFromClientBucket,
} = FileService;
const { requestAccessToken } = AuthCentral;
const { auditDocumentView } = AuditService;
const {
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
} = CoreConsts;

const { DOCUMENTSTORE_SERVICE_URL } = ServiceUrls;

const supportedDocumentTypeService = new SupportedDocumentTypeService({
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
});

const SearchResult = ({
  searchEnsemble,
  _,
  loadMoreData,
  updateParentState,
  sortFields,
  sortFieldId,
  sortOrder,
  updateDigitalFilters,
  metaDefinitions,
  isTriggeredSearch,
}) => {
  const [IsDownloadOpen, setIsDownloadOpen] = useState(false);
  const [OpenSortList, setOpenSortList] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [DocumentsState, setDocumentsState] = useState([]);
  const [AnySelected, setAnySelected] = useState(false);

  useEffect(() => {
    searchEnsemble && setDocumentsState(searchEnsemble.documents);
  }, [searchEnsemble]);

  const downloadDocument = (documentIdentifier, originalFileName) => {
    setisLoading(true);
    downloadFileFromClientBucket(documentIdentifier).then((stream) => {
      const link = document.createElement("a");
      link.setAttribute("href", stream);
      link.setAttribute("download", originalFileName);
      link.click();
      setisLoading(false);
    });
  };

  const canPreviewDocument = (documentMetadatas) =>
    supportedDocumentTypeService.canPreviewDocument(documentMetadatas) ||
    supportedDocumentTypeService.canUsePreviewService(documentMetadatas);

  const viewDocument = async (documentMetadata) => {
    setisLoading(true);

    const documentIdentifier = documentMetadata["document-identifier"];
    const doc = await getDocument(documentIdentifier);
    let Stream;
    let contentType;
    switch (true) {
      case supportedDocumentTypeService.canInlinePreviewDocument(doc):
        Stream = await downloadFileFromClientBucket(documentIdentifier);
        break;
      case supportedDocumentTypeService.canUsePreviewService(doc):
        const { type, Stream: _Stream } =
          await downloadFilePreviewFromClientBucket(documentIdentifier);
        Stream = _Stream;
        contentType = type;
        break;
      default:
        Stream = null;
    }
    const selectedDocument = {
      ...doc,
      "content-type": contentType || doc["content-type"],
      documentUrl: `${DOCUMENTSTORE_SERVICE_URL}api/File/DownloadFileByLink/${doc["document-url-token"]}`,
      Stream,
    };
    setisLoading(false);
    // if (Stream) {
    auditDocumentView(
      documentIdentifier,
      documentMetadata["folder-id"],
      documentMetadata["document-type-id"]
    );
    updateParentState({
      showModal: true,
      selectedDocument,
    });
    // } else {
    //   updateParentState({ NotificationMessage: "Document is not found" });
    // }
  };

  const getDomain = () => {
    const domain = window.location.origin;
    if (domain === "http://localhost:4000") return "http://localhost:3000";
    else if (domain === "https://dev-ox5-hub.oasisgroup.com")
      return "https://dev-ox5-portal.oasisgroup.com";
    else if (domain === "https://qat-ox5-hub.oasisgroup.com")
      return "https://qat-ox5-portal.oasisgroup.com";
    else if (domain === "https://staging-ox5-hub.oasisgroup.com")
      return "https://staging-ox5-portal.oasisgroup.com";
    else if (domain === "https://clienthub.oasisgroup.com")
      return "https://omnidox5.omnidox.co.uk";
    else if (domain === "https://hub.omnidox5.com")
      return "https://portal.omnidox5.com";
  };

  const viewInOmnidox = (ids) => {
    const params = [
      {
        accessTokenAdditionalParamsType: 0,
        accessTokenAdditionalParams: ids,
      },
    ];

    requestAccessToken(params).then((token) => {
      const url = `${getDomain()}/MyDocuments/${token}`;
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("target", "_blank");
      link.click();
    });
  };

  const updateSelectedItems = (itemId, checked) => {
    const index = DocumentsState.findIndex(
      (f) => f.documentMetadata["document-identifier"] === itemId
    );
    if (index >= 0) {
      DocumentsState[index].isChecked = checked;
    }
    setAnySelected(DocumentsState.filter((f) => f.isChecked).length > 0);
    setDocumentsState(DocumentsState);
  };

  const downloadResults = (type) => {
    setisLoading(true);
    downloadDocuments(
      DocumentsState.filter((f) => f.isChecked).map(
        (doc) => doc.documentMetadata["document-identifier"]
      )
    ).then((blob) => {
      var url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "DownloadedFiles.zip");
      link.click();
      setisLoading(false);
    });
  };

  return DocumentsState &&
    DocumentsState.length > 0 &&
    metaDefinitions.length > 0 ? (
    <>
      <div className="result-options">
        {AnySelected && (
          <>
            <div
              className="view-in-bridge"
              onClick={() => {
                viewInOmnidox(
                  DocumentsState.filter((f) => f.isChecked).map(
                    (f) => f.documentMetadata["document-identifier"]
                  )
                );
              }}
            >
              {_.ClientHub.ViewInOmnidox}
            </div>

            <div className="align-self-end download-results">
              <Dropdown
                className="dropdown-toggle portlet-menu-button"
                isOpen={IsDownloadOpen}
                toggle={() => setIsDownloadOpen(!IsDownloadOpen)}
              >
                <DropdownToggle caret>
                  <i className="icon-omni-download"></i>
                  {_.ClientHub.DownloadResults}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => downloadResults(0)}>
                    {_.Download}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </>
        )}
        <div className="sort-by download-results">
          <Dropdown
            className="dropdown-toggle portlet-menu-button"
            isOpen={OpenSortList}
            toggle={() => setOpenSortList(!OpenSortList)}
          >
            <DropdownToggle caret>{_.ClientHub.SortBy}</DropdownToggle>
            {sortFields && (
              <DropdownMenu>
                {sortFields.map((field, key) => (
                  <DropdownItem
                    key={key}
                    style={
                      sortFieldId === field.sortFieldId
                        ? { color: "#fd7e14" }
                        : {}
                    }
                    onClick={() => {
                      updateDigitalFilters({ sortFieldId: field.sortFieldId });
                    }}
                  >
                    {field.sortFieldName}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            )}
          </Dropdown>
        </div>
        {sortOrder === 0 ? (
          <i
            className="icon-omni-down-arrow"
            onClick={() => {
              updateDigitalFilters({ sortOrder: 1 });
            }}
          ></i>
        ) : (
          <i
            className="icon-omni-up-arrow"
            onClick={() => {
              updateDigitalFilters({ sortOrder: 0 });
            }}
          ></i>
        )}
      </div>
      <CustomScroll
        heightRelativeToParent={"calc(100%)"}
        allowInnerScroll={true}
      >
        {DocumentsState.slice(0, searchEnsemble.totalDocumentCount).map(
          (document, index) => {
            return (
              <DigitalCardView
                key={`${document.documentMetadata["document-identifier"]}-${index}`}
                doc={document}
                _={_}
                updateSelectedItems={updateSelectedItems}
                viewDocument={viewDocument}
                canPreviewDocument={canPreviewDocument}
                downloadDocument={downloadDocument}
                viewInOmnidox={viewInOmnidox}
                metaDefinitions={metaDefinitions}
              />
            );
          }
        )}
        {searchEnsemble.totalDocumentCount > DocumentsState.length && (
          <div className="d-flex mt-3 load-more-results justify-content-center ">
            <button
              className="d-flex justify-content-center styled-button "
              type="button"
              onClick={() => loadMoreData()}
            >
              {`Load More Results (${DocumentsState.length} of ${searchEnsemble.totalDocumentCount})`}
            </button>
          </div>
        )}
      </CustomScroll>
      {isLoading && <Preloader />}
    </>
  ) : (
    <div className="no-data">
      {isTriggeredSearch ? _.ClientHub.NoDataResult : ""}
    </div>
  );
};
export const mapStateToProps = ({ _, User }) => ({ _, User });
export default connect(mapStateToProps)(SearchResult);
